<script lang="ts" setup>
import RenderHTML from '~/components/ui/RenderHTML.vue';

defineProps({
  items: {
    type: Array,
    default: () => [],
  },
  title: {
    type: String,
    default: 'Товары',
  },
});
defineEmits(['go-search']);
</script>
<template>
  <ul class="models">
    <li class="mobile-header">{{ title }}</li>
    <li v-for="{ id, image, slug, data } in items" :key="id">
      <nuxt-link :to="`/${slug}/`" @click="$emit('go-search')">
        <div class="img">
          <ui-responsive-image
            :src="image || '/static/images/no-img.svg'"
            draggable="false"
            :mobile-sizes="{ width: 32, height: 32 }"
            :desktop-sizes="{ width: 40, height: 40 }"
          />
        </div>
        <div class="text">
          <RenderHTML :seotext="data" />
        </div>
      </nuxt-link>
    </li>
  </ul>
</template>

<style lang="scss" scoped>
.hint {
  font-weight: 600;
  color: $achromatic-black;
}

.models li:nth-child(2) {
  margin-top: 0;
  padding-top: 0;
  border-top: none;
}

.models li.mobile-header {
  display: block;
  margin-bottom: 16px;
  font-weight: 600;
  color: $achromatic-disabled;

  @include xl-block {
    display: none;
  }

  & + li {
    padding-top: 0;
    border-top: none;
    margin-top: 0;
  }
}

.models {
  li {
    & + li {
      margin-top: 8px;
      padding-top: 8px;
      border-top: 1px solid $achromatic-hover;

      @include md-block {
        padding-top: 12px;
        margin-top: 12px;
      }
      @include xl-block {
        border-top: none;
      }
    }

    a {
      display: flex;
      align-items: center;
      width: 100%;
      text-decoration: none;
      color: inherit;
    }

    .text {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

      span {
        display: inline-flex;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .end-hint {
        width: 100%;
        overflow: hidden;
      }
    }

    .img {
      width: 32px;
      height: 32px;
      min-height: 32px;
      margin-right: 8px;

      @include md-block {
        width: 40px;
        height: 40px;
        min-width: 40px;
        margin-right: 12px;
      }

      &.empty {
        background: $white2;
      }

      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
  }
}
</style>
